import { application } from 'lib/pages-common'
import SlideshowController from 'pages/sell-to-us-page/slideshow-controller'
import GlideSliderController from 'controllers/glide-slider-controller'
import 'intent_form/component_preview'

application.register('slideshow', SlideshowController)
application.register('glide-slider', GlideSliderController)
